;(function () {
  angular
    .module('contrast.user.settings')
    .controller(
      'UserCtrl',
      function (
        $scope,
        $uibModal,
        $rootScope,
        $timeout,
        $translate,
        permissions,
        dialogs,
        logger,
        csTemplates,
        FormData,
        UserFactory,
        UserRASPFactory,
        UserServerlessFactory,
        AuthFactory,
        UserService,
        ErrorService,
        GlobalService,
        PromiseService,
        bulkUploadService,
        freemiumService,
        USER_STATUS,
        ACCESS_EVENTS,
        FREEMIUM_PREFERENCES
      ) {
        'ngInject'

        var _searchKeywords = ''
        var userActiveUrl = 'views/settings/users/template/activate.tpl.html'
        var userUnlockUrl = 'views/settings/users/template/unlock.tpl.html'
        var userInvitationUrl =
          'views/settings/users/template/invitation.tpl.html'
        var userDeleteUrl = 'views/settings/users/template/delete.tpl.html'
        var expandValue = 'preferences,login,role,service_key,online'
        var lastSearch = null
        var quickFiltersPromise = null
        var auth = null

        var translGlobal = {
          title_all_users: $translate.instant('title_all_users'),
          title_pleaseConfirmAction: $translate.instant(
            'title_pleaseConfirmAction'
          ),
          action_cancel: $translate.instant('action_cancel'),
          detail_unableToLoadDialog: $translate.instant(
            'detail_unableToLoadDialog'
          ),
          link_createUser: $translate.instant('link_createUser'),
          link_addUser: $translate.instant('link_addUser'),
          link_activeDirectory: $translate.instant('link_activeDirectory'),
          link_ldap: $translate.instant('link_ldap')
        }

        angular.extend($scope, {
          data: {
            numPerLoad: 15,
            busy: false,
            users: [],
            total: 0,
            row: 'name',
            searchKeywords: searchKeywords
          },
          updating: false,
          userStatuses: USER_STATUS,
          quickFilters: [],
          selectedQuickFilter: {
            name: translGlobal.title_all_users,
            filterType: 'ALL',
            count: '?'
          },
          isEmailUid: GlobalService.getAttributeLabel() == 'Email',
          errorMessages: [],
          showUploadStarted: false,
          errToast: {},
          useUsernameTemplate: false,
          limit: -1,
          link_createUser: translGlobal.link_createUser,
          link_addUser: $translate.instant('link_addUser'),
          link_activeDirectory: $translate.instant('link_activeDirectory'),
          link_ldap: $translate.instant('link_ldap')
        })

        angular.extend($scope, {
          order: order,
          loadByScroll: loadByScroll,
          quickFilterSelect: quickFilterSelect,
          restrictAddUser: restrictAddUser,

          unlock: unlock,
          activate: activate,
          resendInvitation: resendInvitation,
          removeUser: removeUser,
          importUser: importUser,

          toggleEnabled: toggleEnabled,
          toogleRASPEnabled: toogleRASPEnabled,
          toogleServerlessEnabled: toogleServerlessEnabled,

          userUploadCsvChange: userUploadCsvChange,
          closeNotification: closeNotification,
          downloadExample: downloadExample,
          copyServiceKey: copyServiceKey,
          getMostPermissiveRole: getMostPermissiveRole
        })

        function init() {
          $scope.usersPromise = _loadUsers($scope.data.numPerLoad, 0)
          _setAuth()
          _getQuickFilters()

          if (UserService.isFreemiumOrganization()) {
            _getUserLimit()
          }
        }

        function _getUserLimit() {
          freemiumService
            .getPreference(FREEMIUM_PREFERENCES.USERS)
            .then(function (preference) {
              $scope.limit = preference.preference_value
            })
        }

        function restrictAddUser() {
          return $scope.limit != -1 && $scope.limit <= $scope.data.total
        }

        function userUploadCsvChange(file) {
          if (file) {
            var fd = new FormData()
            fd.append('file', file)

            if ($scope.errToast && $scope.errToast.isOpened) {
              $scope.errToast.scope.close(true)
            }
            $scope.showUploadStarted = true

            UserFactory.uploadCsvUsers(fd)
              .then(function (response) {
                $scope.showUploadStarted = false
                logger.logSuccess(response.data.messages[0])
                _reload()
              })
              .catch(function (response) {
                $scope.showUploadStarted = false
                if (!response || !response.data || !response.data.errors) {
                  ErrorService.processError(response)
                } else {
                  $scope.errorMessages =
                    bulkUploadService.buildBulkErrorMessage(
                      response.data.errors,
                      auth,
                      false
                    )

                  // Format error messages
                  var out = ''
                  for (var i = 0; i < $scope.errorMessages.length; i++) {
                    out += $scope.errorMessages[i]
                    if ($scope.errorMessages.length != i + 1) {
                      out += '</br>'
                    }
                  }

                  $scope.errToast = logger.logError(out, {
                    timeOut: 0,
                    extendedTimeOut: 0,
                    tapToDismiss: false,
                    progressBar: false,
                    dismissOnTimeout: false,
                    dismissOnClick: false,
                    dismissButton: true,
                    allowHtml: true
                  })
                }
              })
          }
        }

        function closeNotification() {
          $scope.showUploadStarted = false
        }

        function loadByScroll() {
          if ($scope.data.total <= $scope.data.users.length) {
            return
          }

          $scope.scrollPromise = _loadUsers(
            $scope.data.numPerLoad,
            $scope.data.users.length
          )
          return $scope.scrollPromise
        }

        function order(rowName) {
          if ($scope.data.row === rowName) {
            return
          }

          $scope.data.row = rowName
          _clearUsers()
          $scope.usersPromise = _loadUsers($scope.data.numPerLoad, 0)
        }

        function searchKeywords(newSearchKeywords) {
          if (!arguments.length) {
            return _searchKeywords
          }

          if (newSearchKeywords !== _searchKeywords) {
            _searchKeywords = newSearchKeywords
          }

          _reload()

          return _searchKeywords
        }

        //Modal Dialog
        function unlock(user) {
          return csTemplates
            .loadAndInterpolate(userUnlockUrl, {
              firstName: user.first_name,
              lastName: user.last_name
            })
            .then(
              function (interpolatedStr) {
                var transl = {
                  action_unlock: $translate.instant('action_unlock')
                }

                var dlg = dialogs.confirm(
                  translGlobal.title_pleaseConfirmAction,
                  interpolatedStr,
                  {
                    size: 'sm',
                    yes: transl.action_unlock,
                    no: translGlobal.action_cancel
                  }
                )
                dlg.result.then(function () {
                  UserFactory.unlock(user.user_uid).then(
                    function (response) {
                      logger.logSuccess(response.data.messages[0])
                      _reload()
                    },
                    function (result) {
                      ErrorService.processError(result)
                    }
                  )
                })
              },
              function () {
                logger.logError(translGlobal.detail_unableToLoadDialog)
              }
            )
        }

        function activate(user) {
          return csTemplates
            .loadAndInterpolate(userActiveUrl, {
              firstName: user.first_name,
              lastName: user.last_name
            })
            .then(
              function (interpolatedStr) {
                var transl = {
                  action_activate: $translate.instant('action_activate')
                }

                var dlg = dialogs.confirm(
                  translGlobal.title_pleaseConfirmAction,
                  interpolatedStr,
                  {
                    size: 'sm',
                    yes: transl.action_activate,
                    no: translGlobal.action_cancel
                  }
                )
                dlg.result.then(function () {
                  UserFactory.activate(user.user_uid)
                    .then(function (response) {
                      logger.logSuccess(response.data.messages[0])
                      _reload()
                    })
                    .catch(ErrorService.processError)
                })
              },
              function () {
                logger.logError(translGlobal.detail_unableToLoadDialog)
              }
            )
        }

        function resendInvitation(user) {
          return csTemplates
            .loadAndInterpolate(userInvitationUrl, {
              firstName: user.first_name,
              lastName: user.last_name
            })
            .then(
              function (interpolatedStr) {
                var transl = {
                  action_resend: $translate.instant('action_resend')
                }

                var dlg = dialogs.confirm(
                  translGlobal.title_pleaseConfirmAction,
                  interpolatedStr,
                  {
                    size: 'sm',
                    yes: transl.action_resend,
                    no: translGlobal.action_cancel
                  }
                )
                dlg.result.then(function () {
                  UserFactory.resendInvitation(user.user_uid)
                    .then(function (response) {
                      logger.logSuccess(response.data.messages[0])
                    })
                    .catch(ErrorService.processError)
                })
              },
              function () {
                logger.logError(translGlobal.detail_unableToLoadDialog)
              }
            )
        }

        function removeUser(user) {
          return csTemplates
            .loadAndInterpolate(userDeleteUrl, {
              firstName: user.first_name,
              lastName: user.last_name
            })
            .then(
              function (interpolatedStr) {
                var transl = {
                  action_delete: $translate.instant('action_delete')
                }

                var dlg = dialogs.confirm(
                  translGlobal.title_pleaseConfirmAction,
                  interpolatedStr,
                  {
                    size: 'sm',
                    yes: transl.action_delete,
                    no: translGlobal.action_cancel
                  }
                )
                dlg.result.then(function () {
                  UserFactory.deleteUser(user.user_uid)
                    .then(function (response) {
                      logger.logSuccess(response.data.messages[0])
                      _reload()
                    })
                    .catch(ErrorService.processError)
                })
              },
              function () {
                logger.logError(translGlobal.detail_unableToLoadDialog)
              }
            )
        }

        function toggleEnabled(user) {
          $scope.updating = true
          UserFactory.updateEnabled(user.user_uid, user.enabled_org).then(
            function () {
              var savedUser = _.find($scope.data.users, {
                user_uid: user.user_uid
              })
              savedUser.enabled_org = user.enabled_org
              $scope.updating = false
            },
            function (response) {
              user.enabled_org = !user.enabled_org
              $scope.updating = false
              ErrorService.processError(response)
            }
          )
        }

        function toogleRASPEnabled(user) {
          $scope.raspUpdating = true
          UserRASPFactory.updateEnabled(user.user_uid, user.rasp_enabled).then(
            function () {
              $scope.raspUpdating = false
              $rootScope.$broadcast(ACCESS_EVENTS.ACCESS_RELOAD, {})
              _reload()
            },
            function (response) {
              user.rasp_enabled = !user.rasp_enabled
              $scope.raspUpdating = false
              ErrorService.processError(response)
            }
          )
        }

        function toogleServerlessEnabled(user) {
          $scope.serverlessUpdating = true
          UserServerlessFactory.updateEnabled(
            user.user_uid,
            user.serverless_enabled
          ).then(
            function () {
              $scope.serverlessUpdating = false
              $rootScope.$broadcast(ACCESS_EVENTS.ACCESS_RELOAD, {})
              _reload()
            },
            function (response) {
              user.serverless_enabled = !user.serverless_enabled
              $scope.serverlessUpdating = false
              ErrorService.processError(response)
            }
          )
        }

        function importUser(user, orgName) {
          var modalInstance = $uibModal.open({
            templateUrl: 'views/settings/users/modal_import.html',
            controller: 'ModalImportUserInstanceCtrl',
            resolve: {
              user: function () {
                return user
              },
              orgName: function () {
                return orgName
              }
            },
            size: 'md'
          })

          modalInstance.result.then(function () {
            _reload()
          })
        }

        function quickFilterSelect(filter) {
          $scope.selectedQuickFilter = filter
          _reload()
        }

        function _loadUsers(limit, offset) {
          if (lastSearch) {
            PromiseService.cancelPromise(lastSearch)
          }

          $scope.data.busy = true

          lastSearch = UserFactory.getUsers(
            limit,
            offset,
            _searchKeywords,
            $scope.data.row,
            expandValue,
            $scope.selectedQuickFilter.filterType
          )

          return lastSearch.then(handleUserResponse, handleErrorResponse)
        }

        function handleUserResponse(response) {
          $scope.data.busy = false
          $scope.data.total = response.data.count
          if (
            $scope.data.total >=
            $scope.data.users.length + response.data.users.length
          ) {
            $scope.data.users = $scope.data.users.concat(response.data.users)
            if (response.data.count > 0) {
              $timeout(() => $scope.$emit('triggerScrollCheck'))
            }
          }
        }

        function handleErrorResponse(response) {
          $scope.data.busy = false
          ErrorService.processError(response)
        }

        function _setAuth() {
          AuthFactory.getAuthMode()
            .then(function (response) {
              auth = response.data
              $scope.useUsernameTemplate =
                bulkUploadService.useUsernameTemplate(auth)
            })
            .catch(ErrorService.processError)
        }

        function _getQuickFilters() {
          if (quickFiltersPromise) {
            PromiseService.cancelPromise(quickFiltersPromise)
          }

          quickFiltersPromise = UserFactory.getQuickFilters(searchKeywords())

          quickFiltersPromise
            .then(function (response) {
              $scope.quickFilters = response.data.filters

              $scope.selectedQuickFilter = $scope.quickFilters.find(function (
                filter
              ) {
                return (
                  filter.filterType == $scope.selectedQuickFilter.filterType
                )
              })
            })
            .catch(ErrorService.processError)

          return quickFiltersPromise
        }

        function _clearUsers() {
          $scope.data.users = []
        }

        function _reload() {
          _clearUsers()
          _getQuickFilters()
          $scope.data.loadPromise = _loadUsers($scope.data.numPerLoad, 0)
        }

        function downloadExample() {
          return bulkUploadService.downloadExample(auth, false)
        }

        function copyServiceKey() {
          logger.logSuccess($translate.instant('detail_serviceKeyCopied'))
        }

        function getMostPermissiveRole() {
          return permissions.getMostPermissiveRole()
        }

        init()
      }
    )
})()
